declare const TON_CONNECT_UI_VERSION: string;

export const tonConnectUiVersion: string = "1";
